import React, { useState } from 'react';
import { useLogin } from './hook/useLogin';
import { Input } from '../../components/ui/Input'
import Layout from '../../components/layout/Layout'
import ModalForgotPassword from './modal/ModalForgotPassword';

export default function Login() {
    const {
        errors,
        form,
        handleChange,
        navigate,
        setShowInput,
        showInput,
        onSubmitLogin,
        setShow,
        show
    } = useLogin();
    return (
        <Layout >
            <ModalForgotPassword
                setShow={setShow}
                show={show}
            />
            <div className="min-h-screen flex items-center justify-center bg-white">
                <div className="flex sm:flex-row flex-col rounded-2xl shadow-lg overflow-hidden sm:max-w-4xl w-full">
                    {/* Left Side (Image / Illustration) */}
                    <div className="w-full sm:w-1/2 bg-[#FA6300] flex items-center justify-center relative">
                        <img
                            src="/assets/login.png" // <-- Troque para o caminho correto da imagem
                            alt="Ilustração"
                            className="w-full w-3/4"
                        />
                    </div>

                    {/* Right Side (Form / Text) */}
                    <div className="mt-[-25px] w-full sm:w-1/2 bg-white p-10 flex flex-col justify-center items-center space-y-6">
                        <img
                            src="/assets/logo-lojao-bmg.png"
                            alt="Ilustração"
                            className="w-full sm:w-3/4"
                        />
                        {!showInput && <React.Fragment>
                            <button onClick={() => setShowInput(true)} className="w-48 py-2 bg-[#462A71] text-white rounded-lg font-semibold hover:opacity-[0.8] transition">
                                Entrar
                            </button>
                            <button onClick={() => navigate('/register')} className="w-48 py-2 border-2 border-[#462A71] text-[#462A71] rounded-lg font-semibold hover:bg-pink-50 transition">
                                Cadastrar
                            </button>
                        </React.Fragment>}
                        {showInput && <React.Fragment>
                            <div className='w-full'>
                                <Input className="w-full" name='email' value={form.email} onChange={handleChange} type='text' label='E-mail' placeholder='seu@email.com' />
                                {errors["email"] && <p className="text-red-500 text-sm">{errors["email"]}</p>}
                            </div>
                            <div className='w-full'>
                                <Input className="w-full" maxLength={20} name='password' value={form.password} onChange={handleChange} type='password' label='Senha' placeholder='********' />
                                {errors["password"] && <p className="text-red-500 text-sm">{errors["password"]}</p>}
                            </div>
                            <span className='text-gray-400'>Esqueceu a senha? <button onClick={()=> setShow(true)} className='text-blue-500 hover:underline duration-300'>clique aqui</button></span>
                            <button onClick={onSubmitLogin} className="w-48 py-2 bg-[#462A71] text-white rounded-lg font-semibold hover:opacity-[0.8] transition">
                                Entrar
                            </button>
                        </React.Fragment>}
                    </div>
                </div>
            </div>
        </Layout>
    );
}
